<template>
  <div class="personal-info" v-loading="loading">
    <!-- 基本信息 -->
    <div class="section">
      <div class="section-header">
        <div class="section-title">基本信息</div>
        <div>
          <el-button v-if="!isEditing" type="primary" size="small" class="edit-btn" @click="showPasswordDialog">修改密码</el-button>
          <el-button v-if="!isEditing" type="primary" size="small" icon="el-icon-edit" class="edit-btn" @click="handleEdit">编辑</el-button>
          <el-button v-else type="primary" size="small" icon="el-icon-check" class="edit-btn" :loading="saving" @click="handleFinish">完成</el-button>
        </div>
      </div>

      <!-- 头像 -->
      <div class="avatar-row">
        <ImageUpload
          style="border-radius: 50%"
          v-model="userInfo.headPortrait"
          :size="{ width: '74px', height: '74px' }"
          dir="avatar"
          class="avatar-upload"
          :disabled="!isEditing"
          @preview="showLicensePreview"
        />
        <div class="avatar-right">
          <div class="avatar-tip">只支持JPG、JPEG或PNG格式的图片文件</div>
        </div>
      </div>

      <!-- 基本信息表单 -->
      <el-form :model="userInfo" label-position="top" class="info-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="用户名">
              <el-input v-model="userInfo.userName" :disabled="!isEditing" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input v-model="userInfo.relationName" :disabled="!isEditing" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="职务">
              <el-input v-model="userInfo.postName" :disabled="!isEditing" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="userInfo.relationPhone" :disabled="!isEditing" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="微信号">
              <el-input v-model="userInfo.wxNumber" :disabled="!isEditing" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 企业信息 -->
    <div class="section">
      <div class="section-header">
        <div class="section-title">企业信息</div>
      </div>

      <el-form :model="userInfo" label-position="top" class="info-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业名称">
              <el-input v-model="userInfo.enterpriseName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="userInfo.address" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="E-mail">
              <el-input v-model="userInfo.mail" :disabled="!isEditing" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 公司营业执照 -->
        <el-form-item label="公司营业执照" class="license-item">
          <ImageUpload v-model="licenseList" :multiple="true" :limit="5" dir="license" :disabled="!isEditing" />
        </el-form-item>
      </el-form>
    </div>

    <!-- 图片大图预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" custom-class="password-dialog-other" :visible.sync="passwordDialogVisible" width="400px">
      <el-form :model="passwordForm" label-position="left" style="margin-top: 20px">
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPass" type="password" placeholder="请输入原密码" show-password />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPass" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="再次输入新密码">
          <el-input v-model="passwordForm.confirmPass" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handlePasswordSubmit">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMyUserInfo, editUser } from "@/api";
import { updatePass } from "@/api/login";
import ImageUpload from "@/components/ImageUpload.vue";

export default {
  name: "PersonalInfo",
  components: { ImageUpload },
  data() {
    return {
      loading: false,
      saving: false,
      isEditing: false,
      dialogVisible: false,
      dialogImageUrl: "",
      passwordDialogVisible: false,
      passwordForm: {
        oldPass: "",
        newPass: "",
        confirmPass: "",
      },
      userInfo: {
        userId: null,
        headPortrait: "",
        userName: "",
        enterpriseName: "",
        relationName: "",
        relationPhone: "",
        postName: "",
        role: "",
        wxNumber: "",
        mail: "",
        address: "",
        businessLicense: "",
      },
    };
  },
  computed: {
    licenseList: {
      get() {
        const raw = this.userInfo.businessLicense;
        if (!raw) return [];
        if (Array.isArray(raw)) return raw;
        return raw.split(",").filter(Boolean);
      },
      set(val) {
        this.userInfo.businessLicense = Array.isArray(val) ? val.join(",") : val;
      },
    },
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      this.loading = true;
      try {
        const res = await getMyUserInfo();
        if (res.code === 200 && res.data) {
          this.userInfo = { ...this.userInfo, ...res.data };
          localStorage.setItem("userRes", JSON.stringify(res.data));
        }
      } catch (error) {
        this.$message.error("获取用户信息失败");
      } finally {
        this.loading = false;
      }
    },
    handleEdit() {
      this.isEditing = true;
    },
    async handleFinish() {
      if (this.userInfo.relationPhone && !/^1[3-9]\d{9}$/.test(this.userInfo.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      this.saving = true;
      try {
        const res = await editUser(this.userInfo);
        if (res.code === 200) {
          this.$message.success("保存成功");
          this.isEditing = false;
          const cached = JSON.parse(localStorage.getItem("userRes") || "{}");
          const merged = { ...cached, ...this.userInfo };
          delete merged.password;
          localStorage.setItem("userRes", JSON.stringify(merged));
        } else {
          this.$message.error(res.msg || "保存失败");
        }
      } catch (error) {
        this.$message.error("保存失败，请稍后重试");
      } finally {
        this.saving = false;
      }
    },
    showLicensePreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    showPasswordDialog() {
      this.passwordDialogVisible = true;
      this.passwordForm = {
        oldPass: "",
        newPass: "",
        confirmPass: "",
      };
    },
    async handlePasswordSubmit() {
      // 验证表单
      if (!this.passwordForm.oldPass) {
        this.$message.warning("请输入原密码");
        return;
      }
      if (!this.passwordForm.newPass) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (this.passwordForm.newPass.length < 6) {
        this.$message.warning("新密码长度不能少于6位");
        return;
      }
      if (!this.passwordForm.confirmPass) {
        this.$message.warning("请再次输入新密码");
        return;
      }
      if (this.passwordForm.newPass !== this.passwordForm.confirmPass) {
        this.$message.warning("两次输入的密码不一致");
        return;
      }

      try {
        const res = await updatePass({
          oldPass: this.passwordForm.oldPass,
          newPass: this.passwordForm.newPass,
        });
        if (res.code === 200) {
          this.$message.success("密码修改成功");
          this.passwordDialogVisible = false;
        } else {
          this.$message.error(res.msg || "密码修改失败");
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error);
      }
    },
  },
};
</script>
<style>
.password-dialog-other {
  padding: 20px;
  border-radius: 20px;
}
.password-dialog-other .el-form-item__label {
  line-height: normal;
}
</style>

<style scoped>
.personal-info {
  background: #ffffff;
  border-radius: 8px;
  padding: 22px 30px;
  min-height: 600px;
}

/* ---------- 区块 ---------- */
.section {
  margin-bottom: 12px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.section-title {
  position: relative;
  padding-left: 12px;
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
}

.section-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  width: 6px;
  height: 22px;
  background: #1869ff;
  border-radius: 100px;
}

.edit-btn {
  background: #1869ff;
  border-color: #1869ff;
  font-size: 14px;
}

/* ---------- 头像 ---------- */
.avatar-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.avatar-upload {
  margin-right: 15px;
  flex-shrink: 0;
}

.avatar-upload >>> .upload-image-wrapper,
.avatar-upload >>> .upload-placeholder {
  border-radius: 50% !important;
  overflow: hidden;
}

.avatar-upload >>> .upload-placeholder {
  border: 1px dashed #d9d9d9;
  background: #f0f4fa;
}

.avatar-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.avatar-tip {
  font-size: 12px;
  color: #999999;
}

/* ---------- 表单 ---------- */
.info-form >>> .el-form-item {
  margin-bottom: 20px;
}

.info-form >>> .el-form-item__label {
  padding: 0 0 4px 0;
  line-height: 20px;
  font-size: 16px;
  color: #999999;
}
.info-form >>> .el-input {
  font-size: 16px;
}

.info-form >>> .el-input.is-disabled .el-input__inner {
  background-color: #f0f4fa;
  border-color: #e4e7ed;
  color: #333333;
  cursor: default;
}

/* ---------- 营业执照 ---------- */
.license-item >>> .el-form-item__content {
  line-height: 0;
}
</style>
